"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerStateIcon = void 0;
const isValidAnswer_1 = __importDefault(require("@opsbase/lib-form/helpers/isValidAnswer"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CircleIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CircleIcon"));
const TickIcon_1 = __importDefault(require("@opsbase/web-icons/icons/TickIcon"));
const PercentCircle_1 = __importDefault(require("@opsbase/web-ui/PercentCircle"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (backColor, size) => ({
    root: {
        borderRadius: '50%',
        width: size,
        height: size,
        backgroundColor: backColor.main,
    },
});
function AnswerStateIcon(props) {
    const { color, size = 24 } = props;
    const { answer, question, rule } = (0, usePerformQuestion_1.default)();
    const answerPctCompletion = (0, react_1.useMemo)(() => { var _a; return (_a = props.percentCompletion) !== null && _a !== void 0 ? _a : ((0, isValidAnswer_1.default)(answer, question, rule) ? 100 : 0); }, [answer, props.percentCompletion, question, rule]);
    const isAnswered = answerPctCompletion === 100;
    const isPartiallyAnswered = answerPctCompletion > 0 && answerPctCompletion < 100;
    const answerFlag = answer === null || answer === void 0 ? void 0 : answer.flag;
    const answerColor = (0, react_1.useMemo)(() => isAnswered
        ? answerFlag
            ? (0, Flag_1.flagColor)(answerFlag)
            : lib_palette_1.default.positive
        : color
            ? color
            : lib_palette_1.default.Platinum, [answerFlag, color, isAnswered]);
    const backColor = (0, react_1.useMemo)(() => (color ? color : isAnswered ? lib_palette_1.default.White : lib_palette_1.default.LavendarGrey), [color, isAnswered]);
    const myCss = (0, web_css_1.default)(makeMyClasses, [backColor, size]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: myCss.root }, isPartiallyAnswered ? (react_1.default.createElement(PercentCircle_1.default, { size: 24, percent: answerPctCompletion, label: '', color: lib_palette_1.default.progress })) : isAnswered ? (react_1.default.createElement(TickIcon_1.default, { size: size, color: answerColor })) : (react_1.default.createElement(CircleIcon_1.default, { size: size, color: answerColor })))), [answerColor, isAnswered, isPartiallyAnswered, myCss, answerPctCompletion, size]);
}
exports.AnswerStateIcon = AnswerStateIcon;
exports.default = AnswerStateIcon;
